"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInputRootBox = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _createFocusRingStyles = require("../../../util/createFocusRingStyles");
var _withFocusClassName = require("../../../util/withFocusClassName");
var _TextInputRootBase = require("./TextInputRootBase");
var _formInputTheme = require("./formInputTheme");
const TextInputRootBox = (0, _withFocusClassName.withFocusToggleClassName)((0, _styled.default)(_TextInputRootBase.TextInputRootBase)`
    border-style: solid;
    border-width: ${_formInputTheme.getBorderWidth}px;
    border-color: ${_formInputTheme.getBorderColor};
    border-radius: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _formInputTheme.formInputTheme.borderRadius(themeMode);
}};
    background-color: ${_formInputTheme.getBackgroundColor};
    // This is necessary, and not baked into the StyledInput, to give DatePickerInput a way to override padding for the calendar icon button
    padding-right: ${_ref2 => {
  let {
    hasContentAfter
  } = _ref2;
  return hasContentAfter ? "4px" : "0px";
}};
    ${_ref3 => {
  let {
    themeMode,
    validationState
  } = _ref3;
  return _formInputTheme.formInputTheme.focusRing.enabled(themeMode) && (0, _createFocusRingStyles.createFocusRingStyles)({
    gap: _formInputTheme.formInputTheme.focusRing.offset(themeMode),
    componentBorderWidth: validationState === "error" ? _formInputTheme.formInputTheme.borderWidth.error(themeMode) : _formInputTheme.formInputTheme.borderWidth.rest(themeMode),
    componentRadius: _formInputTheme.formInputTheme.borderRadius(themeMode),
    theme: themeMode,
    focusSelector: ":focus-within"
  });
}}

    & input {
        outline: none;
    }
`);
exports.TextInputRootBox = TextInputRootBox;
//# sourceMappingURL=TextInputRootBox.js.map